import React, { useEffect, useState } from "react";
import { desktop, tablet } from "./BreakPoints";

export function ResponsiveDeviceViewLimiter(props:React.PropsWithChildren<{
    mobile?: boolean;
    tablet?: boolean;
    desktop?: boolean;
}>): JSX.Element {

    const [screenSize, setScreenSize] = useState('');
  
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width <= tablet) {
                setScreenSize('mobile');
            } else if (width <= desktop) {
                setScreenSize('tablet');
            } else {
                setScreenSize('desktop');
            }
        };
  
        handleResize();
        window.addEventListener('resize', handleResize);
    
        // Ryd eventlistener ved unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if(screenSize === 'mobile' && props.mobile)
        return <>{props.children}</>;
    
    else if(screenSize === 'tablet' && props.tablet)
        return <>{props.children}</>;
    
    else if(screenSize === 'desktop' && props.desktop)
        return <>{props.children}</>;

    else
        return <></>;
}